// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ol-1";
export var messageSideRight = "_ol-2";
export var subscribeToBackInStockBubbleContainer = "_ol-0";